import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import myPhoto from '../../images/personal-img/crop-high-brighness.jpg';
import { Link } from 'react-router-dom';
import { FaFacebook, FaGithub, FaFile, FaLinkedin } from 'react-icons/fa';


const About = () => {
    useEffect(() => {
        Aos.init({ duration: 1500 });
    }, [])
    return (
        <div className='w-11/12 px-4 mx-auto mt-10'>
            <div className='flex justify-center items-center'>
                <h2 data-aos='flip-left' className='text-xl mb-5 lg:text-4xl font-semibold text-center md:mb-5 border border-blue-600 inline-block rounded rounded-tl-full rounded-br-full px-10 py-2 '>About Myself</h2>
            </div>
            <div className='home-content justify-center items-center lg:p-10 grid grid-cols-1 md:grid-cols-2'>
                <div className=' flex justify-center items-center' data-aos='flip-left'>
                    <img className='w-3/4 rounded-lg' src={myPhoto} alt="" />
                </div>
                <div className='flex justify-center items-center mt-8 md:mt-0' data-aos='flip-right'>

                    <div>
                        <h2 className='text-3xl font-bold text-gray-500'>MD NURUL AMIN</h2>
                        <div className='grid grid-cols-1 md:grid-cols-2 mb-4 text-gray-500 font-semibold'>

                            <div>
                                <p className='mt-2'>Village : Rotonpur</p>
                                <p className='mt-2'>Post : Gohorpur</p>
                                <p className='mt-2'>District : Sylhet</p>
                                <p className='mt-2'>Country : Bangladesh</p>
                            </div>
                            <div>
                                <p className='mt-2'>Age : 28 Years</p>
                                <p className='mt-2'>Passion : Teacher</p>
                                <p className='mt-2'>Phone : +8801764227126</p>
                                <p className='mt-2'>Email : <Link className='text-blue-500' to='https://mail.google.com/mail/u/0/#inbox?compose=CllgCJftMZBSSdSJFVnrHdnchQqhfDPFtCBKfVNTzfjqCnrQPDggjCsdrbZNHKJhVXBGwqCLHgV' target={'_blank'}>maxnewsbd@gmail.com</Link></p>
                            </div>

                        </div>

                        <div>

                            <p className='text-justify'>Hi, This is <span className='font-semibold'>MD Nurul Amin</span>, I'm a <span className='font-semibold'>Front-End Web Developer</span> || <span className='font-semibold'>Mern Stack Web Developer</span> || <span className='font-semibold'>Front-End Web Designer.</span> I Have More Then 1+ Year Experience in Web Development, And I Have Complete Many Projects in This Time. </p>
                            <div>
                                <button className='custom-btn mt-3 px-4 py-2 border rounded-tl-3xl rounded hover:bg-blue-600 font-semibold border-blue-600 mr-3'><Link className='flex justify-center items-center' to='https://drive.google.com/file/d/1VaV5waqTtfP8TBU7QXPojKEgb7l8M6Sk/view?usp=sharing' target={'_blank'}><FaFile></FaFile> <span className='ml-1'>Resume</span></Link></button>
                                <button className='custom-btn mt-3 px-4 py-2 border rounded-tl-3xl rounded hover:bg-blue-600 font-semibold border-blue-600 mr-3'><Link className='flex justify-center items-center' to='https://github.com/ProDesignerNurul' target={'_blank'}> <FaGithub></FaGithub> <span className='ml-1'>GitHub</span></Link></button>
                                <button className='custom-btn mt-3 px-4 py-2 border rounded-tl-3xl rounded hover:bg-blue-600 font-semibold border-blue-600 mr-3'><Link className='flex justify-center items-center' to='https://web.facebook.com/mdnurul.amin.rsn' target={'_blank'}><FaFacebook></FaFacebook> <span className='ml-1'>Facebook</span></Link></button>
                                <button className='custom-btn mt-3 px-4 py-2 border rounded-tl-3xl rounded hover:bg-blue-600 font-semibold border-blue-600 mr-3'><Link className='flex justify-center items-center' to='https://www.linkedin.com/in/md-nurul-amin-bd/' target={'_blank'}><FaLinkedin></FaLinkedin> <span className='ml-1'>Linkedin</span></Link></button>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;